<template>
    <div class="dashboard-container">
        <side-bar></side-bar>
        <div class="main-content">
            <div class="container">
                <partner-breadcrumbs></partner-breadcrumbs>
            </div>
            <div class="container">
                <!-- Header -->
                <h3 class="campaign-title">VIEW OUTBOUND CAMPAIGN - {{ data.campaignName }}</h3>
                <!-- Tabs -->
                <div class="tabs">
                    <div class="tab-header">
                        <button class="tab-button" @click="activeTab = 'settings'"
                            :class="{ active: activeTab === 'settings' }">settings</button>
                        <!-- <button class="tab-button" @click="activeTab = 'statistics'"
                        :class="{ active: activeTab === 'statistics' }">Statistics</button> -->
                        <button class="tab-button" @click="activeTab = 'targetList'"
                            :class="{ active: activeTab === 'targetList' }">Target List</button>
                    </div>
                    <!-- Settings Tab -->
                    <div v-if="activeTab === 'settings'">
                        <!-- General Settings -->
                        <div class="section">
                            <h4>GENERAL SETTINGS</h4>
                            <div class="form-row-inline">
                                <div>
                                    <label>AI Agent Name*</label>
                                    <input type="text" v-model="data.botName" />
                                </div>
                                <div>
                                    <label>Campaign Name*</label>
                                    <input type="text" v-model="data.campaignName" disabled />
                                </div>
                            </div>
                        </div>
                        <!-- Schedule Settings -->
                        <div class="section">
                            <h4>SCHEDULE SETTINGS</h4>
                            <div class="form-row">
                                <label>Time Zone*</label>
                                <input type="text" v-model="data.timeZone" disabled />
                            </div>
                        </div>

                        <!-- Campaign Time -->
                        <div class="section">
                            <h4>CAMPAIGN TIME</h4>
                            <div class="form-row-inline">
                                <div>
                                    <label>Start Time</label>
                                    <input type="time" v-model="data.startTime" />
                                </div>
                                <div>
                                    <label>End Time <font-awesome-icon class="info-icon" icon="fa-circle-info"
                                            v-b-tooltip.hover
                                            title="End Time must be greater than Start Time and the Current time, all in the same timezone" /></label>
                                    <input type="time" v-model="data.endTime" :min="minEndTime" />
                                    <small class="input-note">End Time must be greater than Start Time and the Current
                                        time,
                                        all in the same timezone</small>
                                </div>
                            </div>
                            <div class="form-row">
                                <label>Campaign Days</label>
                                <div class="days">
                                    <label v-for="day in daysOfWeek" :key="day">
                                        <input type="checkbox" v-model="data.campaignDays" :value="day" />
                                        {{ day }}
                                    </label>
                                    <label>
                                        <input type="checkbox" v-model="everyday" @change="toggleSelectAll" />
                                        Everyday
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Campaign Date Range -->
                        <div class="section">
                            <h4>CAMPAIGN DATE RANGE</h4>
                            <div class="form-row-inline">
                                <div>
                                    <label>Start Date*
                                        <font-awesome-icon class="info-icon" icon="fa-circle-info" v-b-tooltip.hover
                                            title="Start date needs to be in the future" />
                                    </label>
                                    <input type="date" v-model="data.startDate" :min="minStartDate" />
                                </div>
                                <div>
                                    <label>End Date*
                                        <font-awesome-icon class="info-icon" icon="fa-circle-info" v-b-tooltip.hover
                                            title="End date should be greater than start date" />
                                    </label>
                                    <input type="date" v-model="data.endDate" :min="data.startDate" />
                                </div>
                            </div>
                        </div>

                        <!-- Call Rate Settings -->
                        <div class="section">
                            <h4>CALL RATE SETTINGS</h4>
                            <div class="form-row-inline">
                                <div>
                                    <label>Maximum Calls Per Second* <small>(Range: 1-30)</small></label>
                                    <input type="number" v-model="data.maxCallsPerSecond" />
                                </div>
                                <div>
                                    <label>Maximum Concurrent Calls* <small>(Range: 1-100)</small></label>
                                    <input type="number" v-model="data.maxConcurrentCalls" />
                                </div>
                            </div>
                        </div>

                        <!-- Call Failure Settings -->
                        <div class="section">
                            <h4>CALL FAILURE AND ANSWERING MACHINE SETTINGS</h4>
                            <div class="form-row-inline">
                                <div>
                                    <label>Maximum Retries <small>(Range: 1-10)</small></label>
                                    <input type="number" v-model="data.maxRetries" />
                                </div>
                                <div>
                                    <label>Minimum Duration Between Retries <small>(Range: 1-400
                                            min)</small></label>
                                    <input type="number" v-model="data.minDurationBetweenRetries" />
                                </div>
                            </div>
                            <div class="form-row-inline">
                                <div>
                                    <label>Action Triggered By Machine Detection</label>
                                    <input type="text" value="Disconnect" v-model="data.machineDetectionAction"
                                        disabled />

                                </div>
                                <div>
                                    <label>Minimum Wait Time For Answer <small>(Range: 1-300
                                            sec)</small></label>
                                    <input type="number" v-model="data.minWaitTimeForAnswer" />
                                </div>
                            </div>
                        </div>
                        <p class="customization-note">
                            For additional options and customizations, please email us at
                            <a href="mailto:support@trimate.ai">support@trimate.ai</a>.
                        </p>
                        <!-- Footer -->
                        <div class="footer">
                            <div class="buttons">
                                <button class="close-btn" @click="closeForm">Close</button>
                                <button class="update-btn" @click="updateCampaign">Update</button>
                            </div>
                        </div>
                    </div>

                    <!-- Statistics Tab -->
                    <div v-if="activeTab === 'statistics'">
                        <p>Statistics content goes here...</p>
                    </div>

                    <!-- Target List Tab -->
                    <div v-if="activeTab === 'targetList'">

                        <!-- Target List Table -->
                        <div class="section">
                            <table class="target-list-table">
                                <thead>
                                    <tr>
                                        <th>Target Phone Number</th>
                                        <th>Status</th>
                                        <th>Retries</th>
                                        <th>Reschedules</th>
                                        <th>Last Failure Reason</th>
                                        <th>Metadata</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loading">
                                        <td colspan="7">Loading targets...</td>
                                    </tr>
                                    <tr v-else-if="error">
                                        <td colspan="7">Error: {{ error }}</td>
                                    </tr>
                                    <tr v-else-if="campaignTargets.length === 0">
                                        <td colspan="7">No targets found.</td>
                                    </tr>
                                    <tr v-else v-for="target in paginatedCampaignTargets" :key="target.targetNumber">
                                        <td>{{ target.targetNumber }}</td>
                                        <td>{{ target.status }}</td>
                                        <td>{{ target.retries }}</td>
                                        <td>{{ target.reschedules }}</td>
                                        <td>{{ target.failureReason }}</td>
                                        <td>
                                            <pre class="metadata-box">{{ formatMetadata(target.botMetadata) }}</pre>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-controls mt-4">
                                <span class="text-caption">
                                    Showing {{ Math.min((targetPage - 1) * targetItemsPerPage + 1,
                                        campaignTargets.length) }} -
                                    {{ Math.min(targetPage * targetItemsPerPage, campaignTargets.length) }}
                                    of {{
                                        campaignTargets.length }}
                                </span>
                                <v-pagination v-if="targetPageCount > 1" v-model="targetPage" :length="targetPageCount"
                                    density="compact" size="small" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import SideBar from './SideBar.vue'
import PartnerBreadcrumbs from './PartnerBreadcrumbs.vue'
import OutboundCampaign from './OutboundTargets.vue'

export default {
    name: 'UpdateCampaign',
    components: {
        SideBar,
        PartnerBreadcrumbs,
        OutboundCampaign

    },
    data() {
        return {
            activeTab: 'settings',
            daysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            everyday: false,
            customerGUID: "",
            campaignId: "",
            botId: null,
            loading: false,
            error: null,
            data: {
                botName: '',
                campaignName: '',
                timeZone: '',
                startTime: '',
                endTime: '',
                campaignDays: [],
                startDate: '',
                endDate: '',
                maxCallsPerSecond: 0,
                maxConcurrentCalls: 0,
                maxRetries: 0,
                minDurationBetweenRetries: 0,
                machineDetectionAction: '',
                minWaitTimeForAnswer: 0,
            },
            targets: [
                { targetNumber: '', botMetadata: '' }
            ],
            specialTargets: [
                { contractorName: '', contactNumber: '', companyName: '' }
            ],
            campaignTargets: [],
            targetPage: 1,
            targetItemsPerPage: 50,
            minStartDate: '',
            selectedState: 'All',
            australianStates: []
        }
    },
    created() {
        this.australianStates = [
            { value: 'All', text: 'All States' },
            { value: 'NSW', text: 'New South Wales' },
            { value: 'QLD', text: 'Queensland' },
            { value: 'VIC', text: 'Victoria' },
        ];
    },
    computed: {
        targetPageCount() {
            return Math.ceil(this.campaignTargets.length / this.targetItemsPerPage);
        },
        paginatedCampaignTargets() {
            const start = (this.targetPage - 1) * this.targetItemsPerPage;
            const end = start + this.targetItemsPerPage;
            return this.campaignTargets.slice(start, end);
        },
        minEndTime() {
            const now = new Date();
            const today = this.formatDate(now);

            if (this.data.startDate === today) {
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                const currentTime = `${hours}:${minutes}`;

                // End time must be greater than start time and current time
                return this.data.startTime > currentTime ? this.data.startTime : currentTime;
            }
            return this.data.startTime;
        },
        showOutboundCampaignTab() {
            const allowedCustomerGUIDs = [
                "764514EE-B876-4E98-86F5-3339AF2C0FFA",
                "BC359469FC114747BC5B29F35CB25D0F", "AD19537023AE4333B185521BF7078F60"

            ];

            return allowedCustomerGUIDs.includes(this.customerGUID);
        }
    },
    watch: {
        'data.campaignDays': {
            handler(newDays) {
                this.everyday = newDays.length === this.daysOfWeek.length;
            },
            deep: true,
        },
        activeTab(newTab) {
            if (newTab === 'targetList' && this.campaignTargets.length === 0) {
                this.getCampaignTargets();
            }
        },
        selectedState(newVal) {
            console.log('Selected State:', newVal);
        }
    },
    mounted() {
        // Reset bot details
        localStorage.removeItem('botDisplayName');
        localStorage.removeItem('botID');
        localStorage.removeItem('botType');
        localStorage.removeItem('botDID');
        this.customerGUID = (localStorage.getItem("customerGUID") || "").toUpperCase();
        this.campaignId = this.$route.query.campaignid;
        this.getCampaignDetails();

        const today = new Date();
        this.minStartDate = this.formatDate(today);
    },
    methods: {
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        formatMetadata(metadata) {
            if (!metadata || metadata === 'N/A') {
                return 'N/A';
            }
            try {
                const parsed = JSON.parse(metadata);
                return JSON.stringify(parsed, null, 2);
            } catch (e) {
                return metadata;
            }
        },
        toggleSelectAll() {
            if (this.everyday) {
                this.data.campaignDays = [...this.daysOfWeek];
            } else {
                this.data.campaignDays = [];
            }
        },
        closeForm() {
            this.$router.push({ path: '/partner/customer', query: { activeTab: 'outboundCampaign' } });
        },
        // get Campaign data
        async getCampaignDetails() {
            this.loading = true;
            this.error = null;
            try {
                const baseUrl = process.env.VUE_APP_VORTEX_PORTAL_WS;
                const res = await fetch(
                    `${baseUrl}/customers/${this.customerGUID}/campaign?CampaignID=${this.campaignId}`,
                    {
                        method: "GET",
                        headers: { "Accept": "application/json" },
                    }
                );
                if (!res.ok) throw new Error("Failed to fetch campaign details");
                const data = await res.json();
                const c = data.campaign;

                this.botId = c.defaultBotName || null;
                this.data.botName = c.defaultBotDisplayName || '';
                this.data.campaignName = c.campaignName || '';
                this.data.timeZone = c.schedulerSettings?.timeZone || '';
                this.data.startTime = c.schedulerSettings?.startLocalTime || '';
                this.data.endTime = c.schedulerSettings?.stopLocalTime || '';

                if (c.schedulerSettings?.daysOfWeek?.includes('Everyday')) {
                    this.everyday = true;
                    this.data.campaignDays = [...this.daysOfWeek];
                } else {
                    this.everyday = false;
                    this.data.campaignDays = c.schedulerSettings?.daysOfWeek || [];
                }

                this.data.startDate = c.schedulerSettings?.beginningDate || '';
                this.data.endDate = c.schedulerSettings?.endingDate || '';

                this.data.maxCallsPerSecond = c.schedulerSettings?.maxCps || 0;
                this.data.maxConcurrentCalls = c.schedulerSettings?.maxConcurrentCalls || 0;

                this.data.maxRetries = c.maxRetries || 0;
                this.data.minDurationBetweenRetries = c.schedulerSettings?.minDurationBetweenRetries || 0;

                this.data.machineDetectionAction = 'Disconnect';

                this.data.minWaitTimeForAnswer = c.detectionCapabilities?.minWaitDurationForAnswer || 0;

            } catch (err) {
                this.error = err.message;
            } finally {
                this.loading = false;
            }
        },

        async getCampaignTargets() {
            this.loading = true;
            this.error = null;
            try {
                const baseUrl = process.env.VUE_APP_VORTEX_PORTAL_WS;
                const url = `${baseUrl}/customers/${this.customerGUID}/campaign/${this.campaignId}/targets`;
                const res = await fetch(url, {
                    method: "GET",
                    headers: { "Accept": "application/json" },
                });
                if (!res.ok) throw new Error("Failed to fetch campaign targets");
                const data = await res.json();
                if (data.success && Array.isArray(data.targets)) {
                    this.campaignTargets = data.targets.map(t => ({
                        targetNumber: t.setting?.targetNumber || 'N/A',
                        status: t.status?.status || 'N/A',
                        retries: t.status?.numOfRetries ?? 0,
                        reschedules: t.status?.numOfReschedules ?? 0,
                        failureReason: t.status?.lastFailureReason || 'N/A',
                        botMetadata: t.setting?.botMetadata || 'N/A',
                    }));
                }
            } catch (err) {
                this.error = err.message;
            } finally {
                this.loading = false;
            }
        },

        // Update campaign
        async updateCampaign() {
            this.loading = true;
            this.error = null;

            // Time validation
            const now = new Date();
            const today = this.formatDate(now);

            if (this.data.startDate === today) {
                const currentTimeInTimeZone = new Date().toLocaleTimeString('en-GB', { timeZone: this.data.timeZone, hour: '2-digit', minute: '2-digit' });
                if (this.data.startTime < currentTimeInTimeZone) {
                    alert('Start time cannot be in the past for today\'s date.');
                    return;
                }
            }
            if (this.data.endTime <= this.data.startTime) {
                alert('End Time must be greater than Start Time.');
                return;
            }

            try {
                const payload = {
                    campaignName: this.data.campaignName,
                    maxRetries: Number(this.data.maxRetries) || 3,
                    schedulerSettings: {
                        maxCps: Number(this.data.maxCallsPerSecond) || 1,
                        beginningDate: this.data.startDate,
                        daysOfWeek: this.data.campaignDays,
                        endingDate: this.data.endDate,
                        maxConcurrentCalls: Number(this.data.maxConcurrentCalls) || 10,
                        startLocalTime: this.data.startTime,
                        stopLocalTime: this.data.endTime,
                        minDurationBetweenRetries: Number(this.data.minDurationBetweenRetries) || 5,
                    },
                    detectionCapabilities: {
                        minWaitDurationForAnswer: Number(this.data.minWaitTimeForAnswer) || 20,
                        machineDetection: this.data.machineDetectionAction,
                        answerMachineBeepTimeout: 20,
                    },
                };

                const baseUrl = process.env.VUE_APP_VORTEX_PORTAL_WS;
                const url = `${baseUrl}/customers/${this.customerGUID}/campaign/${this.campaignId}`;

                const res = await fetch(url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!res.ok) {
                    const errorData = await res.json();
                    throw new Error(errorData.message || "Failed to update campaign");
                }

                const result = await res.json();
                alert("Campaign updated successfully!");

            } catch (err) {
                this.error = err.message;
                alert("Error updating campaign: " + err.message);
            } finally {
                this.loading = false;
            }
        },


    }
}
</script>


<style scoped>
.campaign-title {
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #f0f0f0;
    text-transform: uppercase;
    letter-spacing: 1px;
}

/* Tabs in single line */
.tabs {
    display: flex;
    margin-bottom: 20px;
}

/* Side-by-side tab content */
.tab-content {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

/* Tab styling */
.tab {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    cursor: pointer;
    padding-bottom: 5px;
    text-transform: uppercase;
    position: relative;
}

.tab.active {
    color: #e45f2b;
}

.tab.active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -1px;
    width: 100%;
    height: 2px;
    background-color: #e45f2b;
}

.tab:hover {
    color: #e45f2b;
}

/* Section titles */
.section {
    margin: 25px;
}

.section h4 {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 15px;
    color: #444;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
}

/* Form rows */
.form-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 15px;
}

.form-row-inline {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
}

.form-row-inline>div {
    flex: 1;
}

/* Inputs */
input[type="text"],
input[type="number"],
input[type="time"],
input[type="date"],
select {
    width: 100%;
    padding: 6px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

input:focus,
select:focus {
    outline: none;
    border-color: #e45f2b;
}

/* Days checkboxes */
.days {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    font-size: 14px;
}

.days input {
    margin-right: 5px;
}

/* Footer */
.footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 25px;
}

.footer a {
    font-size: 13px;
    color: #e45f2b;
    text-decoration: none;
}

.footer a:hover {
    text-decoration: underline;
}

.buttons {
    display: flex;
    gap: 10px;
}

.close-btn,
.update-btn {
    align-self: flex-start;
    cursor: pointer;
    border: 1px solid;
    border-radius: 20px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 400;
    height: 34px;
    padding: 0 1.25rem;
    text-align: center;
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
}

.close-btn {
    background-color: #FFFFFF;
    border-color: #E45F2B;
    color: #E45F2B;
}

.close-btn:hover {
    background-color: #E45F2B;
    color: #FFFFFF;
}

.update-btn {
    color: #FFFFFF;
    background-color: #E45F2B;
    border-color: #E45F2B;
}

.update-btn:hover {
    background: black;
    border-color: black;
}

.customization-note {
    clear: both;
    padding-top: 20px;
    font-size: 14px;
    color: #555;
    font-style: italic;
}

.customization-note a {
    color: #e45f2b;
    text-decoration: underline;
}

/* add target style */
.finish-button {
    background-color: #E45F2B;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 20px;
    cursor: pointer;

}

/* CSV Upload Section Styles */
.upload-section {
    padding: 10px 10px 25px 10px;
    font-family: 'Montserrat', sans-serif;
    text-align: left;
    margin-bottom: 20px;
    width: 95%;
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    border-radius: 6px;
}

.upload-section h3 {
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;
    font-weight: 600;
}

.csv-upload-input {
    padding: 8px 12px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    width: 50%;
    margin-bottom: 8px;
}

.note {
    font-size: 13px;
    color: #555;
    margin-top: 6px;
    line-height: 1.4;
}

/* Container padding */
.container {
    padding: 20px;
    font-family: 'Montserrat', sans-serif;
}

/* Header row */
.target-table-header {
    display: flex;
    background-color: #333c49;
    color: white;
    font-weight: bold;
    padding: 12px 10px;
    border-radius: 6px 6px 0 0;
    font-size: 16px;
}

/* Header columns */
.column {
    flex: 1;
    text-align: left;
}

.target-table-header .column,
.target-table-row .target-input {
    flex: 1;
}

.target-table-header .column:nth-child(2),
.target-table-row .target-input:nth-child(2) {
    flex: 2;
}

.target-table-row .special-target-input {
    flex: 1;
}

.target-table-row .target-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
}

.column-btn {
    width: 100px;
}

/* Input and target rows */
.target-table-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    margin-bottom: 12px;
}

/* Input fields */

/* Displayed target values */
.target-value {
    flex: 1;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
}

/* Add button */
.add-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #E45F2B;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    padding: 10px 15px;
    font-size: 14px;
    transition: background-color 0.2s ease-in-out;
}

.add-btn:hover {
    background-color: #000000;
}

.remove-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    padding: 6px 10px;
    background-color: #788e90;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.2s ease-in-out;
}

.remove-btn:hover {
    background-color: #5a686a;
}

.target-list-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    overflow: hidden;
}

.target-list-table th,
.target-list-table td {
    padding: 14px 18px;
    text-align: left;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    color: #333;
}

.target-list-table th {
    background-color: #333c49;
    font-weight: bold;
    color: white;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.5px;
}

.target-list-table tbody tr:hover {
    background-color: #f5f5f5;
}

.target-list-table td:first-child {
    font-weight: 500;
}

.target-records {
    margin-top: 10px;
}

.pagination-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text-caption {
    font-size: 12px;
    color: #555;
}

.info-icon {
    margin-left: 5px;
    color: #FE602F;
    cursor: default;
}
</style>
